import { useUpdateEntityApi } from '@/common/api/updateEntityApi';
import type { MappingProfile, MappingProfileRequest } from 'shared/products/mapping/domain/mappingProfile';
import { useMappingProfileStore } from 'shared/products/mapping/stores/mappingProfileStore';

export interface UpdateMappingProfileResponse {
  ok: true;
  mappingProfile: MappingProfile;
}

export function useUpdateMappingProfile() {
  const store = useMappingProfileStore();

  return useUpdateEntityApi<MappingProfileRequest, UpdateMappingProfileResponse>({
    url: 'mappingProfile',
    translate: (t) => t.products.actions.update,
    async processOk(response) {
      const json = await response.json() as MappingProfile;
      store.add(json);

      return {
        ok: true,
        mappingProfile: json,
      };
    },
  });
}
